import { createFileRoute } from '@tanstack/react-router';
import { OwnersClient } from '@/features/storage/OwnersClient';

export const Route = createFileRoute('/_shell/storage/owners')({
  component: OwnersClient,
});
